import loadable from '@loadable/component';
import productAlertQuery from './query.graphql';

const ProductAlert = loadable(() =>
  import(/* webpackChunkName: "product-alert" */ './product-alert')
);

ProductAlert.graphQL = productAlertQuery;

ProductAlert.loadOrder = [{}];

ProductAlert.variables = v => ({
  id: parseInt(v.id, 10),
});

export default ProductAlert;
